import './template-collection.scss';
import { headerHeight } from '../../scripts/helpers';
import { atQuery } from '../../scripts/components/mediaQueries';
import Cookies from 'js-cookie';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  function updateGridSettings(selector, cookieName, dataAttr) {
    document.querySelectorAll(selector).forEach(element => {
      element.addEventListener('click', () => {
        const cols = element.getAttribute('data-col');
        const gridSettingsWrapper = document.querySelector('[grid-settings-wrapper]');
        gridSettingsWrapper.setAttribute(dataAttr, `grid-${cols}-col`);

        Cookies.set(cookieName, `grid-${cols}-col`, { expires: 1 });
      });
    });
  }

  function applyGridSettings() {
    const gridValueDesktop = Cookies.get('grid-settings-desktop');
    const gridValueMobile = Cookies.get('grid-settings-mobile');

    const gridSettingsWrapper = document.querySelector('[grid-settings-wrapper]');
    if (gridValueDesktop) {
      gridSettingsWrapper.setAttribute('data-grid-desktop', gridValueDesktop);
    } else {
      gridSettingsWrapper.setAttribute('data-grid-desktop', 'grid-4-col');
    }

    if (gridValueMobile) {
      gridSettingsWrapper.setAttribute('data-grid-mobile', gridValueMobile);
    } else {
      gridSettingsWrapper.setAttribute('data-grid-mobile', 'grid-2-col');
    }
  }

  updateGridSettings('[grid-settings-wrapper] .filters-viewer-params .col-view-desktop', 'grid-settings-desktop', 'data-grid-desktop');
  updateGridSettings('[grid-settings-wrapper] .filters-viewer-params .col-view-mobile', 'grid-settings-mobile', 'data-grid-mobile');

  window.addEventListener('load', applyGridSettings);

  // Manage filters drawer opening/closing

  const filtersOpener = templateCollectionSection.querySelector('.filters-opener');
  const filtersContainer = templateCollectionSection.querySelector('.filters__drawer .filters__container');
  const filterClose = templateCollectionSection.querySelector('.filters__drawer .filters-drawer__close');
  if (filtersOpener && filtersContainer) {
    filtersOpener.addEventListener('click', function () {
      filtersContainer.classList.add('open');
      document.querySelector('html').style.overflow = 'hidden';
    });

    if (filterClose) {
      filterClose.addEventListener('click', () => {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
      });
    }

    var closeOnMouseUp = false;
    filtersContainer.addEventListener('mousedown', (e) => {
      if (!filtersContainer.classList.contains('open') || e.target.classList.contains('filters-drawer__content') || e.target.closest('.filters-drawer__content') || e.target.classList.contains('filters-drawer__active-filters__filter') || e.target.closest('.filters-drawer__active-filters__filter')) return;
      closeOnMouseUp = true;
    });

    filtersContainer.addEventListener('mouseup', () => {
      if (closeOnMouseUp) {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
        closeOnMouseUp = false;
      }
    });
  }


  const sortOpener = templateCollectionSection.querySelector('.sort-opener');
  const sortContainer = templateCollectionSection.querySelector('.filter__sort');
  const sortClose = templateCollectionSection.querySelector('.filter__sort .filters-category__list');
  if (sortOpener && sortContainer) {
    sortOpener.addEventListener('click', function () {
      sortContainer.classList.toggle('open');
    });

    if (sortClose) {
      sortClose.addEventListener('click', () => {
        sortContainer.classList.remove('open');
      });
    }
  }

  // Manage active filters' tags

  const filterTopBar = templateCollectionSection.querySelector('.filters-trigger');

  function stickyFilterTopBar() {
    const rect = filterTopBar.getBoundingClientRect();
    const tolerance = 5;

    if (rect.top <= tolerance) {
      if (!filterTopBar.classList.contains('top-position')) {
        filterTopBar.classList.add('top-position');
        sortContainer.style.position = "fixed";
        sortContainer.style.top = headerHeight() + 'px';
      }
    } else {
      if (filterTopBar.classList.contains('top-position')) {
        filterTopBar.classList.remove('top-position');
        sortContainer.classList.add('top-position');
        sortContainer.style.position = "absolute";
        sortContainer.style.top = 'initial';
      }
    }
  }

  window.addEventListener('load', () => {
    stickyFilterTopBar();
  });

  window.addEventListener('scroll', () => {
    stickyFilterTopBar();
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
